import React, { useState } from 'react';
import { FiFileText, FiChevronDown } from 'react-icons/fi';
import { useHubSite } from '../../shared';
import ArticleEditor, { paragraphsHtml, sampleVideoEmbed } from './ArticleEditor';
import { ARTICLE_CATEGORIES, getArticleSample, shortDate } from './newsSamples';

// Article details: headline, category / date / author, summary, the article text (spec 409:10781)
// headline is the page's title (AddNews builds the preview path from it); sample = /edit opens with the spec's article
const ArticleForm: React.FC<{ headline: string; onHeadline: (v: string) => void; sample: boolean }> = ({ headline, onHeadline, sample }) => {
    const { short } = useHubSite();
    const [s] = useState(() => getArticleSample(short));
    const [category, setCategory] = useState(sample ? s.category : ARTICLE_CATEGORIES[0]);
    const [date, setDate] = useState(sample ? s.date : shortDate(new Date()));
    const [author, setAuthor] = useState(short);
    const [summary, setSummary] = useState(sample ? s.summary : '');
    const [initialText] = useState(() => sample ? paragraphsHtml(s.paragraphs[0]) + sampleVideoEmbed() + paragraphsHtml(s.paragraphs[1]) : '');
    // the HTML a real save would send
    const [, setText] = useState(initialText);

    return <section className="card hub-news-form">
        <div className="section-title"><span className="icon-tile"><FiFileText /></span><h2>Article details</h2></div>

        <label className="field">
            <span className="label">Headline<em>· {headline.length} characters — short headlines read best</em></span>
            <input value={headline} placeholder="What’s the news?" onChange={e => onHeadline(e.target.value)} />
        </label>

        <div className="fields three hub-news-fields">
            <label className="field">
                <span className="label">Category</span>
                <span className="hub-news-select">
                    <select value={category} onChange={e => setCategory(e.target.value)}>
                        {ARTICLE_CATEGORIES.map(c => <option key={c}>{c}</option>)}
                    </select>
                    <FiChevronDown />
                </span>
            </label>
            <label className="field">
                <span className="label">Date shown on website</span>
                <input value={date} onChange={e => setDate(e.target.value)} />
            </label>
            <label className="field">
                <span className="label">Author shown<em>(optional)</em></span>
                <input value={author} onChange={e => setAuthor(e.target.value)} />
            </label>
        </div>

        <label className="field">
            <span className="label">Short summary<em>· shown in the list of articles</em></span>
            <textarea value={summary} rows={2} placeholder="One or two sentences" onChange={e => setSummary(e.target.value)} />
        </label>

        <div className="field">
            <span className="label">Article text</span>
            <ArticleEditor initial={initialText} onChange={setText} />
        </div>
    </section>;
};

export default ArticleForm;
